const ACTIVE_CLASS = 'menu-active'

export const closeMenu = (_) => {
    document.body.classList.remove(ACTIVE_CLASS)
    window.dispatchEvent(new Event('off-canvas-close'))
}

const OffCanvasMenuToggle = () => {
    const toggle = document.querySelector('[data-toggle-menu]')

    const toggleMenu = (_) =>
        document.body.classList.contains(ACTIVE_CLASS)
            ? closeMenu()
            : openMenu()

    const openMenu = (_) => document.body.classList.add(ACTIVE_CLASS)

    const handleKeyPress = ({ key }) => {
        if (key.toLowerCase() === 'escape') {
            closeMenu()
        }
    }

    toggle?.addEventListener('click', toggleMenu)
    window.addEventListener('keyup', handleKeyPress)

    return true
}

export default OffCanvasMenuToggle
